// components/Route/Unauthorized.js
import React from "react";

const Unauthorized = () => {
    const handleLogin = () => {
        [
            "userLoggedIn",
            "user",
            "userId",
            "userToken",
            "session_id",
            "session_expiry",
            "last_session_sync",
        ].forEach((key) => localStorage.removeItem(key));

        window.location.replace("/login");
    };

    return (
        <div className="flex flex-col items-center justify-center h-screen text-center px-4 bg-navy text-white">
            <h1 className="text-7xl font-bold mb-4">401</h1>
            <h2 className="text-2xl font-semibold mb-6">
                {" "}
                You must be authenticated to view this page.
            </h2>

            <button
                onClick={handleLogin}
                className="rounded-[6px] bg-white px-6 py-3 text-blue-900 transition hover:bg-gray-200"
            >
                Click here to log in
            </button>
        </div>
    );
};

export default Unauthorized;
